import { getRequest, postFormData, postRequest, putRequest } from './index'

export type DevEncounterCreature = {
  id: number
  name: string
  zoomUrl?: string
  disabled: boolean
}

export type DevEncounter = {
  id: number
  name: string
  creatures: DevEncounterCreature[]
}

export type DevInstance = {
  id: number
  name: string
  gameVersion: string
  encounters: DevEncounter[]
}

export const getDevEncounterCreatures = async () => {
  return getRequest('/dev/api/encounter_creatures') as Promise<{
    instances: DevInstance[]
  }>
}

export const getDevEncounterCreatureSaved = async (encounterId: number) => {
  return getRequest(
    `/dev/api/encounter_creatures/${encounterId}/saved`,
  ) as Promise<{ creatureIds: number[] }>
}

export const saveDevEncounterCreatureImage = async (
  encounterId: number,
  creatureId: number,
  blob: Blob,
) => {
  const formData = new FormData()
  formData.append('file', blob, `${creatureId}.png`)
  return postFormData(
    `/dev/api/encounter_creatures/${encounterId}/${creatureId}`,
    formData,
  ) as Promise<{ path: string }>
}

export const updateDevEncounterCreature = async (
  creatureId: number,
  data: { disabled: boolean },
) => {
  return putRequest(
    `/dev/api/encounter_creatures/${creatureId}`,
    data,
  ) as Promise<{
    id: number
    disabled: boolean
  }>
}

export const syncDevEncounterCreatures = async (instanceId: number) => {
  return postRequest('/dev/api/encounter_creatures/sync', {
    instanceId,
  }) as Promise<{ success: boolean }>
}

export const proxyDevEncounterCreatureImageUrl = (url: string) =>
  `/dev/api/encounter_creatures/image?url=${encodeURIComponent(url)}`
